import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Time_Tracking';
import Self from './components/Time_Tracking_Self';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions, roles, user}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles} user={user}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute exact path={`${match.url}/self`}>
				<Self regions={regions} roles={roles} user={user}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
